<div class="mt-2 h-full">
    <!-- <div class="flex justify-start">
        <dx-check-box [value]="false" text="Switch to editable mode" class="pr-2" (onValueChanged)="switchToEditableMode()"></dx-check-box>
    </div> -->
    <dx-data-grid
        #productMasterDataGrid
        id="gridContainer2"
        [allowColumnResizing]="true"
        [columnResizingMode]="'widget'"
        [allowColumnReordering]="true"
        [dataSource]="productMasterDataSource"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [remoteOperations]="true"
        [hoverStateEnabled]="true"
        [cacheEnabled]="false"
        [(selectedRowKeys)]="productMappingSelectedRowMap"
        (onSelectionChanged)="productSelectionChangedHandler()"
        (onContextMenuPreparing)="productMasterDataGridContextMenu($event)"
        (onCellPrepared)="onCellPrepared($event)"
    >
        <dxo-state-storing
                [enabled]="true"
                type="custom"
                [customLoad]="loadMasterState"
                [customSave]="saveMasterState">
        </dxo-state-storing>
        <dxo-load-panel
                [enabled]="false"
                shadingColor="rgba(0,0,0,0.4)"
                [showIndicator]="true"
                [showPane]="true"
                [shading]="true">
        </dxo-load-panel>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
        <dxo-selection mode="single"></dxo-selection>
        <dxo-column-chooser
                [enabled]="true"
                mode="dragAndDrop"> <!-- or "select" -->
        </dxo-column-chooser>
        <dxo-pager
                [visible]="true"
                [allowedPageSizes]="[5, 10, 25, 50, 100]"
                displayMode="compact"
                [showPageSizeSelector]="true"
                [showNavigationButtons]="false"
        >
        </dxo-pager>
        <dx-context-menu [items]="contextMenuItems"
                         target="#someElement">
        </dx-context-menu>
        <!-- <dxo-editing
            mode="row"
            [allowUpdating]="true"
            [allowDeleting]="false"
            [allowAdding]="true">
        </dxo-editing> -->
        <dxo-search-panel
                [visible]="true"
                [(text)]="searchText"
        ></dxo-search-panel>
        <!-- <dxo-sorting mode="none"></dxo-sorting> -->
        <dxi-column dataField="ProductMasterId" [customizeText]="customizeProductMasterId" [allowEditing]="false" [allowHeaderFiltering]="false"></dxi-column>
        <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" [width]="100" alignment="center"></dxi-column>
        <dxi-column dataField="CompanyName">
            <dxo-header-filter [dataSource]="companyNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="MasterBrandName" caption="Master Brand">
            <dxo-header-filter [dataSource]="masterBrandHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="BrandName" caption="Brand">
            <dxo-header-filter [dataSource]="brandNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="SubBrandName" caption="Sub-brand">
            <dxo-header-filter [dataSource]="subBrandNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="ProductName" caption="Product">
            <dxo-header-filter [dataSource]="productNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="ProductIsNatureInspired" caption="Nature Inspired" [allowHeaderFiltering]="false"></dxi-column>
        <dxi-column dataField="ProductIsMensProduct" caption="Men's Product" [allowHeaderFiltering]="false"></dxi-column>
        <dxi-column dataField="CategoryName" caption="Category">
            <dxo-header-filter [dataSource]="categoryNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="SubcategoryFunctionName" caption="Function Subcategory">
            <dxo-header-filter [dataSource]="subcategoryFunctionNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="SubcategoryFormName" caption="Form Subcategory">
            <dxo-header-filter [dataSource]="subcategoryFormNameHeaderDataSource"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="ProductSizeOnLabel" caption="Product Size - Volume">
            <dxo-header-filter [dataSource]="productSizeOnLabelHeaderDataSource"></dxo-header-filter>
        </dxi-column>

        <div *dxTemplate="let action of 'action'">
            <dx-button
                    class="mr-1"
                    icon="fas fa-map-marker-alt fa-1x"
                    hint="Map"
                    (onClick)="map(action?.data?.ProductMasterId)"></dx-button>
            <dx-button
                    class="mr-1"
                    hint="Edit"
                    icon="fas fa-edit fa-1x"
                    (onClick)="editOrCloneProduct(action?.data, false)"></dx-button>
            <dx-button
                    hint="Clone"
                    icon="fas fa-clone fa-1x"
                    (onClick)="editOrCloneProduct(action?.data, true)"></dx-button>
        </div>
        <dxo-paging [pageSize]="5"></dxo-paging>
        <!-- <dxo-pager
            [showPageSizeSelector]="true"
            [allowedPageSizes]="[8, 12, 20]"
        ></dxo-pager> -->
    </dx-data-grid>
</div>
